/**
 * @NOTE some of these types needs to be moved to dtos repository.
 */

export const chatLogPs = ref(null);

export const chatListPs = ref(null);

export const previousScrollHeightMinusScrollTop = ref();

export const chatLogIsCurrentlyAtBottom = ref(false);

export const scrollToEntry = (entryId: number, entryType: EntryType): void => {
    const entryElement = document.getElementById(`entry_${entryType}_${entryId}`);

    if (!entryElement) {
        return;
    }

    scrollToInChatLog(entryElement.offsetTop - 25); // Extra offset, so its a bit more to top of the contents what results in displaying the avatar/name if present.
};

export const scrollToBottomInChatLog = (): void => {
    scrollToInChatLog((chatLogPs.value?.$el || chatLogPs.value).scrollHeight);
};

const scrollToInChatLog = (position: number): void => {
    const scrollEl = chatLogPs.value?.$el || chatLogPs.value;

    if (!scrollEl) {
        return;
    }

    scrollEl.scrollTop = position;
};

export const scrollToTopInChatList = (): void => {
    const scrollEl = chatListPs.value?.$el || chatListPs.value;

    scrollEl.scrollTop = 0;
};

import { ChannelSettingInterface } from "@/interfaces/channelSettings.interface";
import { Team } from "@/types/team.types";
import { User } from "@/types/user.types";
import {
    Asset,
    ChatsListChat,
    Contact,
    CreatedEntity,
    EntryDirection,
    EntryDtoType,
    EntryStatus,
    EntryStatusReason,
    EntryType,
    EventActor,
    EventPayloadType,
    InformationVariant,
    KeyValueOption,
    Label,
    OriginalMetadata,
    PlatformType,
    ProviderType,
} from "@saysimple-platform/dtos";
import { ref } from "@vue/composition-api";
import { DateTime } from "luxon";

export type ActiveChat = {
    chat: ChatsListChat;
    entries: EntryDtoType[];
    contact: Contact;
} | null;

export type ChatContact = {
    id: number;
    name: string;
    isHighPriority: 0 | 1;
    isBlocked: 0 | 1;
    allowSystemMessages: 0 | 1;
    labels: Label[];
};

export type ChatChannel = {
    id: number;
    name: string;
    platform?: PlatformType;
    provider?: ProviderType;
    customerCareWindowLength?: number;
    teamChannels?: Team[];
    userChannels?: User[];
    settings?: ChannelSettingInterface[];
};

export type ChatEntry = {
    id: number;
    time: DateTime;
    type: EntryType;
    createdById: number;
    createdAt?: string;
    createdByEntity: CreatedEntity;
    direction?: EntryDirection;
    status?: EntryStatus;
    statusReason?: EntryStatusReason;
    message?: string;
    payload?: ChatEntryPayload;
    actor?: EventActor;
    latitude?: number;
    longitude?: number;
    metadata?: KeyValueOption<OriginalMetadata>;
    name?: string;
    url?: string;
    address?: string;
    assets?: Asset[];
    components?: Record<string, unknown>;
    variant?: InformationVariant;
};

export type ChatEntryPayload =
    | EventPayloadType
    | TextPayload
    | AttachmentPayload
    | InformationPayload
    | LocationPayload;

export type TextPayload = string;

export type AttachmentPayload = {
    message: string;
    assets: [];
};
export type InformationPayload = Record<string, unknown> & { variant: InformationVariant };

export type LocationPayload = {
    latitude: number;
    longitude: number;
    name: string;
    address: string;
    url: string;
};

export type EntryGroup = {
    createdBy?: User | Contact;
    createdByEntity: CreatedEntity;
    createdById?: number;
    createdAt: DateTime;
    direction?: EntryDirection;
    entries: Array<{
        id?: number;
        payload?: ChatEntryPayload;
        time: Date | DateTime | string;
        type: EntryType | "date";
        status?: EntryStatus;
        statusReason?: EntryStatusReason;
        components?: Record<string, unknown>;
        metadata?: Record<string, unknown>;
    }>;
};

export type UpdateChatsListChat = Partial<ChatsListChat> & Required<Pick<ChatsListChat, "id">>;

export type CustomerCareWindow = boolean | { hours: number; minutes: number };
